import { render, staticRenderFns } from "./EditSubmissionConfirmDialog.vue?vue&type=template&id=38e33c8d&"
import script from "./EditSubmissionConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./EditSubmissionConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditSubmissionConfirmDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports